import Collapse from "~/components/collabsable";

type ProfessionalMethodenComponent = {
  didacticMethodicalHint?: string;
  inclusionHint?: string;
};

export default function ProfessionalDidacticMethodicalHint({
  didacticMethodicalHint,
  inclusionHint,
}: ProfessionalMethodenComponent) {
  if (!didacticMethodicalHint && !inclusionHint) return null;

  return (
    <Collapse
      defaultOpen={true}
      name={
        <h1 className="text-left text-xl font-bold tracking-tight text-primary md:text-[24px]">
          {didacticMethodicalHint ? "Beschreibung" : ""}
          {inclusionHint && !didacticMethodicalHint
            ? "Hinweise für inklusives Lernen:"
            : ""}
        </h1>
      }
      content={
        <div>
          {didacticMethodicalHint ? (
            <div className="mt-8">
              <div
                className="max-w-2xl overflow-hidden text-[14px] leading-[1.857] tracking-wide text-primary"
                dangerouslySetInnerHTML={{
                  __html: didacticMethodicalHint,
                }}
              />
            </div>
          ) : null}
          {inclusionHint ? (
            <div className="mt-10">
              {didacticMethodicalHint && (
                <h1 className="pb-2 text-[18px]  font-bold text-primary sm:text-lg">
                  Hinweise für inklusives Lernen:
                </h1>
              )}
              <div
                className="max-w-2xl overflow-hidden text-[14px] leading-[1.857] tracking-wide text-primary"
                dangerouslySetInnerHTML={{
                  __html: inclusionHint,
                }}
              />
            </div>
          ) : null}
        </div>
      }
    />
  );
}
